export default [
  {
    "date": "2026-01-20",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x4fbFF399F21c546CD01a1E68e3C4C3102B5456e7",
    "methodToken": "ETH",
    "settledAmount": 93.14
  },
  {
    "date": "2026-01-22",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 4979.11
  },
  {
    "date": "2026-01-22",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 4979.11
  },
  {
    "date": "2026-01-28",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 12440.78
  },
  {
    "date": "2026-01-28",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 12440.78
  },
  {
    "date": "2026-01-29",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 12915.8
  },
  {
    "date": "2026-01-29",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 12915.8
  },
  {
    "date": "2026-01-30",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 20232.19
  },
  {
    "date": "2026-01-30",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 20232.19
  },
  {
    "date": "2026-02-04",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 5011.15
  },
  {
    "date": "2026-02-04",
    "clientName": "Alfons Schoemans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8030471C882130D0dbE808003fAA34Af0CE5A4b4",
    "methodToken": "USDT - ERC20",
    "settledAmount": 5011.15
  },
  {
    "date": "2025-04-03",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qwltjt0w6mfmmflfzekz0tnv0rzzqfjnzk89e4m",
    "methodToken": "BTC",
    "settledAmount": 110.0
  },
  {
    "date": "2025-04-03",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 1001.0
  },
  {
    "date": "2025-10-03",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 4256.69
  },
  {
    "date": "23/05/2025",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x5512CADD1B9577B1a73FfF72057302FC9F183d9f",
    "methodToken": "USDC-ERC20",
    "settledAmount": 8411.87
  },
  {
    "date": "29/05/2025",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 22211.06
  },
  {
    "date": "30/05/2025",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 28409.0
  },
  {
    "date": "31/05/2025",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 28116.33
  },
  {
    "date": "2025-10-06",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 109859.0
  },
  {
    "date": "2025-11-06",
    "clientName": "Antoine VanKerckhove",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "141RKY5moFDE4t7L7RgkMXzi4TuxdpcShk",
    "methodToken": "BTC",
    "settledAmount": 3348.0
  },
  {
    "date": "15/10/2025",
    "clientName": "Aurelie de coster",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x3837eb1e6e949d3ec4d12e15b5ac5b92411426ac",
    "methodToken": "ETH",
    "settledAmount": 123.76
  },
  {
    "date": "2026-01-28",
    "clientName": "Bassiliki psaroudki",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "Dovi WD",
    "methodToken": "",
    "settledAmount": 219.87
  },
  {
    "date": "15/08/2025",
    "clientName": "Beatrice Vanherle",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "Refund",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "28/07/2025",
    "clientName": "Bert Smits",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xE5d31692C20C225B0A732Dc59431ebeFFd003aEc",
    "methodToken": "USDC-ERC20",
    "settledAmount": 108.0
  },
  {
    "date": "2025-01-29",
    "clientName": "bert verschueren",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1G1h9AbyzYGzWKKqoaU6LrUHTSot8WiBrw",
    "methodToken": "BTC",
    "settledAmount": 10204.0
  },
  {
    "date": "2025-02-05",
    "clientName": "bert verschueren",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1G1h9AbyzYGzWKKqoaU6LrUHTSot8WiBrw",
    "methodToken": "BTC",
    "settledAmount": 51663.0
  },
  {
    "date": "18/02/2025",
    "clientName": "bert verschueren",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1G1h9AbyzYGzWKKqoaU6LrUHTSot8WiBrw",
    "methodToken": "BTC",
    "settledAmount": 104037.0
  },
  {
    "date": "29/09/2025",
    "clientName": "Brigitte Palma",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "2025-01-06",
    "clientName": "Bruno De Meyer",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1B4ZWAxgijSuHUjZyXdpGLA7om4e7LBA6t",
    "methodToken": "BTC",
    "settledAmount": 51418.37
  },
  {
    "date": "2025-01-16",
    "clientName": "Bruno De Meyer",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1B4ZWAxgijSuHUjZyXdpGLA7om4e7LBA6t",
    "methodToken": "BTC",
    "settledAmount": 51485.78
  },
  {
    "date": "2025-01-24",
    "clientName": "Bruno De Meyer",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1JGbbQSgNveyNA5bt2giFFnncnc4XihMSW",
    "methodToken": "BTC",
    "settledAmount": 15670.79
  },
  {
    "date": "29/09/2025",
    "clientName": "Bud Victor",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "22/05/2025",
    "clientName": "Carlos Debruyne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x0E9B562151F65b6231762DdBE5358d6D32BBDc7F",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2734.68
  },
  {
    "date": "28/05/2025",
    "clientName": "Carlos Debruyne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1AjUhMWb2D8QkRJS81fHLS31XrPQDXJQRJ",
    "methodToken": "BTC",
    "settledAmount": 2758.95
  },
  {
    "date": "2025-01-28",
    "clientName": "Chris Hoeck",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC5CE1F48Baa4b360f135003d1B11c622EF3B7bD4",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2217.0
  },
  {
    "date": "14/11/2025",
    "clientName": "Chris Vroman",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "362xkDhHTkbh9ycMCYDzifNQHGo9bRAyTc",
    "methodToken": "BTC",
    "settledAmount": 103.08
  },
  {
    "date": "13/03/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xf49515B7Eb3fA8342DD9337eF04Dc647Af50b9a9",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1422.86
  },
  {
    "date": "28/04/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TA3y6WSJpVMScXV3jgBQMSiVtGsmpX3qfX",
    "methodToken": "USDT-TRC20",
    "settledAmount": 10746.58
  },
  {
    "date": "2025-01-05",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1BCqZdmsUh3pLvk8jY93oPFKtzj6Tc4qTw",
    "methodToken": "BTC",
    "settledAmount": 534.0
  },
  {
    "date": "27/05/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xe7f87d74b783ce49bdf978590d11d5d575f86237",
    "methodToken": "",
    "settledAmount": 581.52
  },
  {
    "date": "19/06/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117B0C34F35DDb701AEc8d8dB89B6888D87B8243",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2733.96
  },
  {
    "date": "19/06/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117B0C34F35DDb701AEc8d8dB89B6888D87B8243",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1222.33
  },
  {
    "date": "20/06/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117B0C34F35DDb701AEc8d8dB89B6888D87B8243",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1548.4
  },
  {
    "date": "24/06/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117B0C34F35DDb701AEc8d8dB89B6888D87B8243",
    "methodToken": "ETH-ERC20",
    "settledAmount": 5610.0
  },
  {
    "date": "2025-02-07",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117B0C34F35DDb701AEc8d8dB89B6888D87B8243",
    "methodToken": "ETH",
    "settledAmount": 2274.47
  },
  {
    "date": "24/09/2025",
    "clientName": "Christine Darquenne",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1JMAJsEpH2QkoT3Ee6HmRjBGf3VfhgLZkn",
    "methodToken": "BTC",
    "settledAmount": 2277.4
  },
  {
    "date": "2025-12-05",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2746.0
  },
  {
    "date": "2025-12-05",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2445.0
  },
  {
    "date": "13/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x0D439Ad8A89Bd27e76cd1C23E606B041a23E49d7",
    "methodToken": "USDC-ERC20",
    "settledAmount": 108.0
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4959.65
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4856.38
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4747.05
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4745.39
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4633.4
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4958.49
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4956.37
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4957.21
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 689.43
  },
  {
    "date": "19/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 4956.71
  },
  {
    "date": "20/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2288.0
  },
  {
    "date": "20/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x558B1122cF4d7f3a7F3810e6F95669a46c6dB179",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2769.0
  },
  {
    "date": "28/05/2025",
    "clientName": "Clarys Dirk",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1LY6Yrvtj82pfCVePg9dvB5LoauAvm1hcu",
    "methodToken": "BTC",
    "settledAmount": 111930.0
  },
  {
    "date": "18/04/2025",
    "clientName": "Clement Yacine",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "20/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 9932.9
  },
  {
    "date": "24/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3255.0
  },
  {
    "date": "26/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3652.0
  },
  {
    "date": "26/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3652.0
  },
  {
    "date": "26/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3086.0
  },
  {
    "date": "28/03/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1348.0
  },
  {
    "date": "18/04/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1085.0
  },
  {
    "date": "18/04/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3871.0
  },
  {
    "date": "18/04/2025",
    "clientName": "Danny De mol",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x79c9fEf3597eB577AfeBf2a30F7BC2C22cbE6B0F",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3871.0
  },
  {
    "date": "21/11/2025",
    "clientName": "David HEDGE",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xD7f098Ef427Cc6C2af6C9F578f59d624E696D05f",
    "methodToken": "ETH",
    "settledAmount": 932.32
  },
  {
    "date": "2025-08-10",
    "clientName": "Delplancke Kathleen",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x17063F1C8Beb46B91204B070DF2929c5E723e274",
    "methodToken": "USDC-ERC20",
    "settledAmount": 383.89
  },
  {
    "date": "2026-01-28",
    "clientName": "Denise Vanassche",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "Anywire wd",
    "methodToken": "",
    "settledAmount": 182.62
  },
  {
    "date": "2026-01-30",
    "clientName": "Denise Vanassche",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TXxXPztWvpDUvaQaNBxS8sYY6ZCbzFLWj8",
    "methodToken": "TRC20",
    "settledAmount": 5192.53
  },
  {
    "date": "2026-02-10",
    "clientName": "Denise Vanassche",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TDEBUdDYxyUVHEvDZ1dMoEj49aGWL4UVaD",
    "methodToken": "TRC20",
    "settledAmount": 5198.22
  },
  {
    "date": "2026-02-10",
    "clientName": "Diane D",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x7d266CA7EF1813F1ce7b45c45491E15dB6DE2f69",
    "methodToken": "ETH",
    "settledAmount": 59.07
  },
  {
    "date": "2026-01-16",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x33684a670Dd45936b011eC693b4D13f7e61EB3a5",
    "methodToken": "ETH",
    "settledAmount": 2769.09
  },
  {
    "date": "2026-01-16",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x33684a670Dd45936b011eC693b4D13f7e61EB3a5",
    "methodToken": "ETH",
    "settledAmount": 2769.09
  },
  {
    "date": "2026-01-19",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x33684a670Dd45936b011eC693b4D13f7e61EB3a5",
    "methodToken": "ETH",
    "settledAmount": 2786.76
  },
  {
    "date": "2026-01-19",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x33684a670Dd45936b011eC693b4D13f7e61EB3a5",
    "methodToken": "ETH",
    "settledAmount": 2786.76
  },
  {
    "date": "2026-01-28",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "167SK2Hr9FA5WX1J6qA2mWeEjCn9PS9QGW",
    "methodToken": "BTC",
    "settledAmount": 2952.96
  },
  {
    "date": "2026-01-28",
    "clientName": "Didier Bulteau",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "167SK2Hr9FA5WX1J6qA2mWeEjCn9PS9QGW",
    "methodToken": "BTC",
    "settledAmount": 2952.96
  },
  {
    "date": "2026-01-21",
    "clientName": "Dirk Gheysens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xf9bE321807Bbfd8e21C21Aa1d1a1c6Ed62E83835",
    "methodToken": "USDT - ERC20",
    "settledAmount": 2492.51
  },
  {
    "date": "2026-01-21",
    "clientName": "Dirk Gheysens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xf9bE321807Bbfd8e21C21Aa1d1a1c6Ed62E83835",
    "methodToken": "USDT - ERC20",
    "settledAmount": 2492.51
  },
  {
    "date": "2026-01-23",
    "clientName": "Dirk Gheysens",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x5C2635A5faA23dBD82B3f5B651bB2e15cc6Aa9bB",
    "methodToken": "ETH",
    "settledAmount": 175.98
  },
  {
    "date": "2026-01-29",
    "clientName": "Dirk Gheysens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xf9bE321807Bbfd8e21C21Aa1d1a1c6Ed62E83835",
    "methodToken": "USDT - ERC20",
    "settledAmount": 2538.48
  },
  {
    "date": "2026-01-29",
    "clientName": "Dirk Gheysens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xf9bE321807Bbfd8e21C21Aa1d1a1c6Ed62E83835",
    "methodToken": "USDT - ERC20",
    "settledAmount": 2538.48
  },
  {
    "date": "28/10/2025",
    "clientName": "El Harche Youssef",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Mg2Y8oqDGGHcJeckRTSBr2sLNx5Jx8c7e",
    "methodToken": "BTC",
    "settledAmount": 1677.81
  },
  {
    "date": "2026-02-16",
    "clientName": "Elet Johnny",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16Xnvh1X5hqnLEfyQ1cTUuCYqLAWU9kcBB",
    "methodToken": "BTC",
    "settledAmount": 1170.95
  },
  {
    "date": "27/03/2025",
    "clientName": "Ernest Serville",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xDe2C7F5D6D5EC4Df8241776FDcBa6095dA710BF8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1612.0
  },
  {
    "date": "30/05/2025",
    "clientName": "Ernest Serville",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xDe2C7F5D6D5EC4Df8241776FDcBa6095dA710BF8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2170.92
  },
  {
    "date": "28/10/2025",
    "clientName": "Ernest Serville",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xA780bac47B729216BebFf6734e3E90C5D3F97f27",
    "methodToken": "ETH",
    "settledAmount": 2203.2
  },
  {
    "date": "21/11/2025",
    "clientName": "Ernest Serville",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xA780bac47B729216BebFf6734e3E90C5D3F97f27",
    "methodToken": "ETH",
    "settledAmount": 3333.51
  },
  {
    "date": "2025-04-03",
    "clientName": "Erwin Vanderhaegen",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qsxzs0rnzwgjqkw9eem3clekf2s7d9e34hfsc67",
    "methodToken": "BTC",
    "settledAmount": 40.0
  },
  {
    "date": "2025-01-16",
    "clientName": "FERNAND THIENPONDT",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Nr79rUbBC6RAkQiWVDN2PVmuSbJJtrx8w",
    "methodToken": "BTC",
    "settledAmount": 5059.0
  },
  {
    "date": "2026-01-16",
    "clientName": "Fran\u00e7oise Caudron",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TUfxCtX4fc6Bjndx4DYZkCffkZ8ipCPfZG",
    "methodToken": "TRC20",
    "settledAmount": 2511.54
  },
  {
    "date": "2026-01-16",
    "clientName": "Fran\u00e7oise Caudron",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TUfxCtX4fc6Bjndx4DYZkCffkZ8ipCPfZG",
    "methodToken": "TRC20",
    "settledAmount": 2511.54
  },
  {
    "date": "2026-01-23",
    "clientName": "Frank Comhaire",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "DOVI WD",
    "methodToken": "",
    "settledAmount": 1055.85
  },
  {
    "date": "2026-01-23",
    "clientName": "Frank Comhaire",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TXxXPztWvpDUvaQaNBxS8sYY6ZCbzFLWj8",
    "methodToken": "TRC20",
    "settledAmount": 4359.7
  },
  {
    "date": "2026-01-23",
    "clientName": "Frank Comhaire",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TXxXPztWvpDUvaQaNBxS8sYY6ZCbzFLWj8",
    "methodToken": "TRC20",
    "settledAmount": 4359.7
  },
  {
    "date": "2026-01-26",
    "clientName": "Gaston FOUBERT",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xa9965bc1672be8E60bF4f7F966750D16C785A38d",
    "methodToken": "USDT - ERC20",
    "settledAmount": 24723.86
  },
  {
    "date": "2026-01-26",
    "clientName": "Gaston FOUBERT",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xa9965bc1672be8E60bF4f7F966750D16C785A38d",
    "methodToken": "USDT - ERC20",
    "settledAmount": 25228.43
  },
  {
    "date": "2026-01-26",
    "clientName": "Gaston FOUBERT",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xa9965bc1672be8E60bF4f7F966750D16C785A38d",
    "methodToken": "USDT - ERC20",
    "settledAmount": 10091.37
  },
  {
    "date": "2026-02-06",
    "clientName": "Gaston Foubert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xa9965bc1672be8E60bF4f7F966750D16C785A38d",
    "methodToken": "USDT - ERC20",
    "settledAmount": 25046.17
  },
  {
    "date": "2026-02-11",
    "clientName": "Gaston FOUBERT",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xa9965bc1672be8E60bF4f7F966750D16C785A38d",
    "methodToken": "USDT - ERC20",
    "settledAmount": 10071.17
  },
  {
    "date": "2026-02-02",
    "clientName": "Gerard GOEMAERE",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xc3265C10dD1ae60Fdc06Ade92C2345C79eaCdc11",
    "methodToken": "USDT - ERC20",
    "settledAmount": 10039.55
  },
  {
    "date": "21/02/2025",
    "clientName": "Gino Debacker",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "27/02/2025",
    "clientName": "Gino Debacker",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Fbz2yeSaJJVdku9avoAbT3pbAG67PKEgr",
    "methodToken": "BTC",
    "settledAmount": 997.0
  },
  {
    "date": "23/04/2025",
    "clientName": "Guido van den bergh",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xfe349cC19C16985B82478A7BD8DDfd9ecA164630",
    "methodToken": "USDC-ERC20",
    "settledAmount": 108.0
  },
  {
    "date": "2025-10-12",
    "clientName": "Guy Mputu Ndibo",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "ANYWIRE WD",
    "methodToken": "",
    "settledAmount": 297.96
  },
  {
    "date": "2025-12-02",
    "clientName": "Halima Assaguir",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qm9532n8jlphtqa9tm59g0zcrtm0zxmflf2hs5c",
    "methodToken": "BTC",
    "settledAmount": 40.0
  },
  {
    "date": "2025-01-10",
    "clientName": "Harry Bonnarens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x47b15d708Ee6D0854e1BEcC5a53D292835B1AC92",
    "methodToken": "ETH-ERC20",
    "settledAmount": 989.0
  },
  {
    "date": "2025-01-30",
    "clientName": "Hendrik Dedecker",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x38782A4Ca8F39Ac7fB44500aa2e8fAE62D10bd11",
    "methodToken": "ETH-ERC20",
    "settledAmount": 13423.83
  },
  {
    "date": "2025-01-30",
    "clientName": "Hendrik Dedecker",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x38782A4Ca8F39Ac7fB44500aa2e8fAE62D10bd11",
    "methodToken": "ETH-ERC20",
    "settledAmount": 643.57
  },
  {
    "date": "13/02/2025",
    "clientName": "Hendrik Dedecker",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "18vTVzfYezLpwsvRQHWoQTYdYmyzG9w5NJ",
    "methodToken": "BTC",
    "settledAmount": 12924.73
  },
  {
    "date": "26/05/2025",
    "clientName": "Hendrik Neyens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x117c6ad811304bDfFaC4E764D12B7F7ab70e776D",
    "methodToken": "USDC-ERC20",
    "settledAmount": 2781.72
  },
  {
    "date": "21/11/2025",
    "clientName": "Hendrik Neyens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "125RNmjiwUWp9XYAWhKFFNmRuCkFJf5ktn",
    "methodToken": "BTC",
    "settledAmount": 6695.0
  },
  {
    "date": "30/04/2025",
    "clientName": "Huguette Wanzoul",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TA3y6WSJpVMScXV3jgBQMSiVtGsmpX3qfX",
    "methodToken": "USDT-ERC20",
    "settledAmount": 1489.2
  },
  {
    "date": "30/04/2025",
    "clientName": "Huguette Wanzoul",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TA3y6WSJpVMScXV3jgBQMSiVtGsmpX3qfX",
    "methodToken": "USDT-ERC20",
    "settledAmount": 1489.2
  },
  {
    "date": "17/06/2025",
    "clientName": "Huguette Wanzoul",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1CT5vXK9UtXgp3E8rcxzvK9xC9jhD9q3X7",
    "methodToken": "BTC",
    "settledAmount": 1989.5
  },
  {
    "date": "28/08/2025",
    "clientName": "Huguette Wanzoul",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1MA53XpLLdo7ZyxaKxnmfVowq9y12UUkYS",
    "methodToken": "BTC",
    "settledAmount": 8659.0
  },
  {
    "date": "18/04/2025",
    "clientName": "Iliane Redant iliane",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "CHB",
    "methodToken": "",
    "settledAmount": 258.0
  },
  {
    "date": "29/09/2025",
    "clientName": "Jaak Decaluwe",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "2025-01-08",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Jaxmxp6JaJMi85rC32LCmMf1nbtBv1Wqe",
    "methodToken": "BTC",
    "settledAmount": 6873.0
  },
  {
    "date": "2025-01-22",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Jaxmxp6JaJMi85rC32LCmMf1nbtBv1Wqe",
    "methodToken": "BTC",
    "settledAmount": 13529.0
  },
  {
    "date": "2025-01-28",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1JKcT8Fn3wVamJEYCfRugsWQq2P1P8SoJ",
    "methodToken": "BTC",
    "settledAmount": 10858.87
  },
  {
    "date": "2025-06-02",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1JKcT8Fn3wVamJEYCfRugsWQq2P1P8SoJ",
    "methodToken": "BTC",
    "settledAmount": 8207.16
  },
  {
    "date": "17/02/2025",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Jaxmxp6JaJMi85rC32LCmMf1nbtBv1Wqe",
    "methodToken": "BTC",
    "settledAmount": 8074.0
  },
  {
    "date": "24/02/2025",
    "clientName": "Jan Jacobs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1Jaxmxp6JaJMi85rC32LCmMf1nbtBv1Wqe",
    "methodToken": "BTC",
    "settledAmount": 9726.0
  },
  {
    "date": "2026-01-06",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x92022eA7d331A4b62E9741A8F3437DCa232F7261",
    "methodToken": "ETH",
    "settledAmount": 116.84
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 2653.76
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 2653.76
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 2655.59
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 2655.59
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 1576.9
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 1576.9
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 1516.48
  },
  {
    "date": "14/11/2025",
    "clientName": "Jan Maes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1M3gkkKsqrCmVXJb6GjsjJoLAU7xo952Le",
    "methodToken": "BTC",
    "settledAmount": 1516.48
  },
  {
    "date": "2025-01-03",
    "clientName": "Jan VC",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "18LsMH7j1AgCAMaF4wXRogrMEdzGFn22ii",
    "methodToken": "BTC",
    "settledAmount": 9973.0
  },
  {
    "date": "2025-01-20",
    "clientName": "Jan VC",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qf79f0q9xuu8jj22kzfxrc222egllj6mznnpld9",
    "methodToken": "BTC",
    "settledAmount": 100.0
  },
  {
    "date": "18/02/2025",
    "clientName": "Jan VC",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "17MrcGjbAJgxe6mBxm8RQrkZPEXPZxtrGo",
    "methodToken": "BTC",
    "settledAmount": 31131.84
  },
  {
    "date": "2026-02-16",
    "clientName": "Jean Delannoy",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TDEBUdDYxyUVHEvDZ1dMoEj49aGWL4UVaD",
    "methodToken": "TRC20",
    "settledAmount": 2588.25
  },
  {
    "date": "18/03/2025",
    "clientName": "Jean-Fran\u00e7ois Manno",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xad7E21d24f435E85e64F1648938ba72e658e5629",
    "methodToken": "ETH-ERC20",
    "settledAmount": 7643.0
  },
  {
    "date": "18/03/2025",
    "clientName": "Jean-Fran\u00e7ois Manno",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xad7E21d24f435E85e64F1648938ba72e658e5629",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2442.0
  },
  {
    "date": "27/03/2025",
    "clientName": "Jean-Fran\u00e7ois Manno",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x3De105477d4E25a5cb0e6839A95E4450fC186eb1",
    "methodToken": "ETH-ERC20",
    "settledAmount": 10400.0
  },
  {
    "date": "2026-01-30",
    "clientName": "Jean-Marie Dhaene",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xBBAbD304a854bF1AC44EBcb590f1F47F72D3e495",
    "methodToken": "USDT - ERC20",
    "settledAmount": 20230.71
  },
  {
    "date": "2026-02-11",
    "clientName": "Jean-Marie Dhaene",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xBBAbD304a854bF1AC44EBcb590f1F47F72D3e495",
    "methodToken": "USDT - ERC20",
    "settledAmount": 100696.24
  },
  {
    "date": "2026-01-20",
    "clientName": "jellis verhoeven",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x788f3d7ab71cbc42cfeb8d32081a1c103ec51632",
    "methodToken": "ETH",
    "settledAmount": 58.62
  },
  {
    "date": "2026-01-22",
    "clientName": "Jellis Verhoeven",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x788f3d7ab71cbc42cfeb8d32081a1c103ec51632",
    "methodToken": "ETH",
    "settledAmount": 234.47
  },
  {
    "date": "2025-01-20",
    "clientName": "Johan van mastricht",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x387bb75385bAeacc991A9cCC9435d6c4368efac4",
    "methodToken": "ETH-ERC20",
    "settledAmount": 15347.94
  },
  {
    "date": "2025-01-23",
    "clientName": "Johan van mastricht",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x387bb75385bAeacc991A9cCC9435d6c4368efac4",
    "methodToken": "ETH-ERC20",
    "settledAmount": 7412.37
  },
  {
    "date": "2025-02-03",
    "clientName": "Johan van mastricht",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x387bb75385bAeacc991A9cCC9435d6c4368efac4",
    "methodToken": "ETH-ERC20",
    "settledAmount": 9640.0
  },
  {
    "date": "2025-05-02",
    "clientName": "Johan van mastricht",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HhHb1V2fovHVpFMjtfCNSoUCmXKGMypwY",
    "methodToken": "BTC",
    "settledAmount": 3066.83
  },
  {
    "date": "2025-10-02",
    "clientName": "Josephus Brusselmans",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "13tf8FUx5EeVKHiHVf9Gugdu8TT8FCfuPq",
    "methodToken": "BTC",
    "settledAmount": 2005.47
  },
  {
    "date": "2026-01-07",
    "clientName": "Jp Picarelle",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16UZGA32fa9qBy1Aw3tSU6MAZuagKKdG2B",
    "methodToken": "BTC",
    "settledAmount": 1119.36
  },
  {
    "date": "2026-01-12",
    "clientName": "Jp Picarelle",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16UZGA32fa9qBy1Aw3tSU6MAZuagKKdG2B",
    "methodToken": "BTC",
    "settledAmount": 11344.6
  },
  {
    "date": "2026-01-29",
    "clientName": "Jp Picarelle",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16UZGA32fa9qBy1Aw3tSU6MAZuagKKdG2B",
    "methodToken": "BTC",
    "settledAmount": 3897.89
  },
  {
    "date": "2026-02-10",
    "clientName": "Jp Picarelle",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16UZGA32fa9qBy1Aw3tSU6MAZuagKKdG2B",
    "methodToken": "BTC",
    "settledAmount": 11914.0
  },
  {
    "date": "2026-02-17",
    "clientName": "Jp Picarelle",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "16UZGA32fa9qBy1Aw3tSU6MAZuagKKdG2B",
    "methodToken": "BTC",
    "settledAmount": 3253.28
  },
  {
    "date": "2025-03-12",
    "clientName": "Jules Dubois",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "Anywire WD",
    "methodToken": "",
    "settledAmount": 178.1
  },
  {
    "date": "22/04/2025",
    "clientName": "JULES GILLAUX",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TA3y6WSJpVMScXV3jgBQMSiVtGsmpX3qfX",
    "methodToken": "USDT-TRC20",
    "settledAmount": 10011.94
  },
  {
    "date": "17/06/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 5586.59
  },
  {
    "date": "17/06/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 5586.19
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2673.15
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2673.15
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2673.26
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2673.26
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2672.88
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2672.88
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2639.79
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2639.79
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2559.04
  },
  {
    "date": "17/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2559.04
  },
  {
    "date": "19/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 3153.5
  },
  {
    "date": "19/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 3153.5
  },
  {
    "date": "19/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2679.5
  },
  {
    "date": "19/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1HoMT6gbwqzWBBa15Ej47r2wV8oEpToo6J",
    "methodToken": "BTC",
    "settledAmount": 2679.5
  },
  {
    "date": "25/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4554.0
  },
  {
    "date": "25/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4778.0
  },
  {
    "date": "25/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4891.0
  },
  {
    "date": "25/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4544.0
  },
  {
    "date": "25/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 3919.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4483.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4485.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4710.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 2110.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4490.0
  },
  {
    "date": "26/09/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4598.0
  },
  {
    "date": "2025-02-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4534.4
  },
  {
    "date": "2025-02-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4527.0
  },
  {
    "date": "2025-02-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1B860F735429B0aC59DAe03C242095d5CeCc4462",
    "methodToken": "ETH",
    "settledAmount": 4527.17
  },
  {
    "date": "2025-02-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4530.8
  },
  {
    "date": "2025-02-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1B860F735429B0aC59DAe03C242095d5CeCc4462",
    "methodToken": "ETH",
    "settledAmount": 4412.86
  },
  {
    "date": "2025-09-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4434.63
  },
  {
    "date": "2025-09-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 3879.84
  },
  {
    "date": "2025-09-10",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 2741.77
  },
  {
    "date": "15/10/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4350.94
  },
  {
    "date": "15/10/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 4466.44
  },
  {
    "date": "15/10/2025",
    "clientName": "J\u00fcrgen Bossaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8d4F05664537AC3Ce0b575802Bb8a57a8dB39e35",
    "methodToken": "ETH",
    "settledAmount": 2212.59
  },
  {
    "date": "2026-01-19",
    "clientName": "Kathleen Ferrant",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x888586D59d0d420573D2C9DDe2527A35653bC443",
    "methodToken": "USDC - ERC20",
    "settledAmount": 2551.15
  },
  {
    "date": "2026-01-23",
    "clientName": "Kathleen Ferrant",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x888586D59d0d420573D2C9DDe2527A35653bC443",
    "methodToken": "USDC - ERC20",
    "settledAmount": 1700.35
  },
  {
    "date": "2025-01-03",
    "clientName": "Katleen Vrancken",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1NY8tNed1voUHe9f2y9Z1Tz3fUXGbfXciC",
    "methodToken": "BTC",
    "settledAmount": 157426.0
  },
  {
    "date": "2025-01-09",
    "clientName": "Katleen Vrancken",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1NY8tNed1voUHe9f2y9Z1Tz3fUXGbfXciC",
    "methodToken": "BTC",
    "settledAmount": 61441.38
  },
  {
    "date": "2025-12-03",
    "clientName": "Kevin Perdaen",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3AW42yVwKpCRDVpkq8GxCRLqnRhVYYHgvX",
    "methodToken": "BTC",
    "settledAmount": 60.0
  },
  {
    "date": "2025-10-04",
    "clientName": "Kevin Perdaen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1778AD3F33250AcA3A95A30d9a5766102Cba875a",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1063.0
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 4597.7
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 1880.41
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 4820.72
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 5493.22
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 5379.87
  },
  {
    "date": "24/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x9D3D5A277476547EcF95A104eeba6502CE036c7F",
    "methodToken": "USDC-ER20",
    "settledAmount": 5051.28
  },
  {
    "date": "25/04/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x704EeF99cE0a4f3bE879052d1d25F009F5699244",
    "methodToken": "USDC-ERC20",
    "settledAmount": 108.0
  },
  {
    "date": "2025-11-06",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TWnA4VtNPfyfJCtLMCDDf54YcjVYXZtmyR",
    "methodToken": "USDT-TRC20",
    "settledAmount": 13619.89
  },
  {
    "date": "25/07/2025",
    "clientName": "Luc De Groof",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "136MJY8rcnzU4EbAKbUt8U2NgnvKJ97xHL",
    "methodToken": "BTC",
    "settledAmount": 17369.58
  },
  {
    "date": "14/10/2025",
    "clientName": "Luc Leaucour",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "CHB",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "19/12/2025",
    "clientName": "LUCAS GURDEBEKE",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "Dovi",
    "methodToken": "",
    "settledAmount": 410.02
  },
  {
    "date": "2025-11-11",
    "clientName": "LUT WOLFS",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x49dA031a0092DF091643DD54e365C9A17a91c8c0",
    "methodToken": "ETH",
    "settledAmount": 183.0
  },
  {
    "date": "18/09/2025",
    "clientName": "Marc Blondeel",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x2c200819a292F72e4dACC339c873F4f00b34b399",
    "methodToken": "USDC-ERC20",
    "settledAmount": 126.37
  },
  {
    "date": "23/09/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 13226.02
  },
  {
    "date": "23/09/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 13226.02
  },
  {
    "date": "20/06/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TKWV6M3V9edSnZBQSVbQ44DxqGhTkTGH9c",
    "methodToken": "USDT-TRC20",
    "settledAmount": 2849.0
  },
  {
    "date": "20/06/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TKWV6M3V9edSnZBQSVbQ44DxqGhTkTGH9c",
    "methodToken": "USDT-TRC20",
    "settledAmount": 2850.25
  },
  {
    "date": "2025-08-09",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 7789.51
  },
  {
    "date": "2025-08-09",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 7789.51
  },
  {
    "date": "2025-09-09",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 11057.87
  },
  {
    "date": "2025-09-09",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 11057.87
  },
  {
    "date": "15/09/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 13226.01
  },
  {
    "date": "15/09/2025",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xC3193267Bb403DF407BB5Fd82ae2FeB159B6D804",
    "methodToken": "USDT-ERC20",
    "settledAmount": 13226.01
  },
  {
    "date": "2025-10-10",
    "clientName": "MARC DE KINDER",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1GmhQuZQTTk8CY8CjWdhdGJkQFa2GiGq48",
    "methodToken": "BTC",
    "settledAmount": 28780.0
  },
  {
    "date": "2026-02-06",
    "clientName": "Marc Van Gehuchten",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TDEBUdDYxyUVHEvDZ1dMoEj49aGWL4UVaD",
    "methodToken": "TRC20",
    "settledAmount": 25811.21
  },
  {
    "date": "2026-01-19",
    "clientName": "Marcel Van Mechelen",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3DDuwwwXLx9sEQbG99TQUFcgHV2ceV6gLZ",
    "methodToken": "BTC",
    "settledAmount": 1000.34
  },
  {
    "date": "2026-02-17",
    "clientName": "Marcel Van Mechelen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1D273f97e7A4dA8B7Ab9BfCaaa8Caed810b05720",
    "methodToken": "USDT - ERC20",
    "settledAmount": 38577.77
  },
  {
    "date": "2026-02-18",
    "clientName": "Marcel Van Mechelen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1D273f97e7A4dA8B7Ab9BfCaaa8Caed810b05720",
    "methodToken": "USDT - ERC20",
    "settledAmount": 57169.14
  },
  {
    "date": "23/12/2025",
    "clientName": "Marcel Vanderhaegen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x2Cf3912227Ce27B0ea19AE584e95e361D4e387BA",
    "methodToken": "ETH",
    "settledAmount": 2825.88
  },
  {
    "date": "29/12/2025",
    "clientName": "Marcel Vanderhaegen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x2Cf3912227Ce27B0ea19AE584e95e361D4e387BA",
    "methodToken": "ETH",
    "settledAmount": 2263.63
  },
  {
    "date": "2026-01-16",
    "clientName": "Marcel VanMechelen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1D273f97e7A4dA8B7Ab9BfCaaa8Caed810b05720",
    "methodToken": "USDT - ERC20",
    "settledAmount": 19604.43
  },
  {
    "date": "2026-01-22",
    "clientName": "Marcel VanMechelen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1D273f97e7A4dA8B7Ab9BfCaaa8Caed810b05720",
    "methodToken": "USDT - ERC20",
    "settledAmount": 49901.73
  },
  {
    "date": "26/05/2025",
    "clientName": "Margriet Leunis",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xe6D5b39CE46984732595E97896832cDe27ba5D2A",
    "methodToken": "USDC-ERC20",
    "settledAmount": 11274.2
  },
  {
    "date": "2025-03-06",
    "clientName": "Margriet Leunis",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qr095zpxt8a93fdzlyqakhz4laqvey6z44cug7p",
    "methodToken": "BTC",
    "settledAmount": 110.0
  },
  {
    "date": "2025-05-12",
    "clientName": "Marguillier Mihaela",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "35Ja7iM2b5uuycYAEuQXpxcrDLFkoWUi9g",
    "methodToken": "BTC",
    "settledAmount": 110.0
  },
  {
    "date": "2025-03-07",
    "clientName": "MarieAnn De Rijck",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x9EE9D185a4F22d33A1A9E6f28274f7Aa3e44fA8F",
    "methodToken": "USDC-ERC20",
    "settledAmount": 208.0
  },
  {
    "date": "2025-07-07",
    "clientName": "MarieAnn De Rijck",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xFD3c5Db759F4f1FadC5F748b8dbD2D19c57f715c",
    "methodToken": "ETH",
    "settledAmount": 4822.24
  },
  {
    "date": "2025-05-08",
    "clientName": "MarieAnn De Rijck",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x4111E831503603EFAddDA96308268408830c59b6",
    "methodToken": "ETH",
    "settledAmount": 4320.79
  },
  {
    "date": "2025-05-08",
    "clientName": "MarieAnn De Rijck",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x4111E831503603EFAddDA96308268408830c59b6",
    "methodToken": "ETH",
    "settledAmount": 2295.9
  },
  {
    "date": "2025-01-07",
    "clientName": "Marleen Stubbe",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x30cad73A043A09EDa491fD9E359ED3eEd346B8c5",
    "methodToken": "ETH-ERC20",
    "settledAmount": 4916.55
  },
  {
    "date": "19/02/2025",
    "clientName": "Marleen Stubbe",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1DhSHWaBbVNm2Tu9Fvyq1JmjM3aXq83d69",
    "methodToken": "BTC",
    "settledAmount": 26135.04
  },
  {
    "date": "21/02/2025",
    "clientName": "Marleen Stubbe",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1KduminYFDCrJGUUQT1NvaGY3Fd3BVjBz9",
    "methodToken": "BTC",
    "settledAmount": 5188.67
  },
  {
    "date": "26/05/2025",
    "clientName": "Martine sluyts",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "WD",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "28/02/2025",
    "clientName": "Minneke Binnemans",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 260.0
  },
  {
    "date": "2026-02-17",
    "clientName": "Monique Lemmens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xA57399D078980667CfeC134d4F3B05EdcF4B1eC0",
    "methodToken": "USDT - ERC20",
    "settledAmount": 20092.59
  },
  {
    "date": "2026-02-19",
    "clientName": "Monique Lemmens",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "W2C Hasbul",
    "methodToken": "",
    "settledAmount": 1302.68
  },
  {
    "date": "2025-02-05",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x64623bb074eF8Ea5EDb84B1AD23611F70Be070c8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2478.0
  },
  {
    "date": "14/02/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x64623bb074eF8Ea5EDb84B1AD23611F70Be070c8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3109.76
  },
  {
    "date": "20/02/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x64623bb074eF8Ea5EDb84B1AD23611F70Be070c8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 6541.9
  },
  {
    "date": "2025-03-04",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x64623bb074eF8Ea5EDb84B1AD23611F70Be070c8",
    "methodToken": "ETH-ERC20",
    "settledAmount": 10134.99
  },
  {
    "date": "22/04/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF293Fd3CedeD119b489761A1B788aCb1f232f7A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3057.0
  },
  {
    "date": "22/04/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF293Fd3CedeD119b489761A1B788aCb1f232f7A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1674.41
  },
  {
    "date": "29/04/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF293Fd3CedeD119b489761A1B788aCb1f232f7A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1310.1
  },
  {
    "date": "30/04/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF293Fd3CedeD119b489761A1B788aCb1f232f7A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1013.0
  },
  {
    "date": "30/04/2025",
    "clientName": "Monique Perilleux",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF293Fd3CedeD119b489761A1B788aCb1f232f7A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3160.58
  },
  {
    "date": "2026-01-22",
    "clientName": "Natacha Matth\u00e9",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xe57bEFAa8b49415162D2B05981227eBA50782Db8",
    "methodToken": "ETH",
    "settledAmount": 20.0
  },
  {
    "date": "2025-04-11",
    "clientName": "ndombo Ndombo Mpuasa",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xe33f0e5F48A88E840C954157Da1A7d98B3B4aAEA",
    "methodToken": "ETH",
    "settledAmount": 1783.95
  },
  {
    "date": "2026-01-07",
    "clientName": "Nicolas De Flo",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x688777Da1c2E7677695d3C84D0CB8B4A67E51a87",
    "methodToken": "ETH",
    "settledAmount": 233.71
  },
  {
    "date": "2026-01-07",
    "clientName": "Nicolas De Flo",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x2552033Ec55204F8b5f23063ca45b1235e54Ca96",
    "methodToken": "USDT - ERC20",
    "settledAmount": 4437.98
  },
  {
    "date": "2026-01-07",
    "clientName": "Nicolas De Flo",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x2552033Ec55204F8b5f23063ca45b1235e54Ca96",
    "methodToken": "USDT - ERC20",
    "settledAmount": 4437.98
  },
  {
    "date": "2026-01-14",
    "clientName": "Nicolas de Flo",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x688777Da1c2E7677695d3C84D0CB8B4A67E51a87",
    "methodToken": "ETH",
    "settledAmount": 234.88
  },
  {
    "date": "2026-02-02",
    "clientName": "Nicolas De Flo",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x688777Da1c2E7677695d3C84D0CB8B4A67E51a87",
    "methodToken": "ETH",
    "settledAmount": 1489.73
  },
  {
    "date": "2026-02-02",
    "clientName": "Nicolas De Flo",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x688777Da1c2E7677695d3C84D0CB8B4A67E51a87",
    "methodToken": "ETH",
    "settledAmount": 1489.73
  },
  {
    "date": "28/11/2025",
    "clientName": "Nodi Lizette",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xe1D3044Ad0a242F890AcB5F22c3b2F2c964176f0",
    "methodToken": "ETH",
    "settledAmount": 1093.26
  },
  {
    "date": "2025-03-07",
    "clientName": "Pascal Wuytens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x3c953a58e78E4e6Cb27F491C7f06ae2A14062f4C",
    "methodToken": "ETH",
    "settledAmount": 4401.23
  },
  {
    "date": "2025-03-07",
    "clientName": "Pascal Wuytens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x3c953a58e78E4e6Cb27F491C7f06ae2A14062f4C",
    "methodToken": "ETH",
    "settledAmount": 2591.9
  },
  {
    "date": "2025-03-07",
    "clientName": "Pascal Wuytens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x3c953a58e78E4e6Cb27F491C7f06ae2A14062f4C",
    "methodToken": "ETH",
    "settledAmount": 4407.54
  },
  {
    "date": "2025-03-07",
    "clientName": "Pascal Wuytens",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x3c953a58e78E4e6Cb27F491C7f06ae2A14062f4C",
    "methodToken": "ETH",
    "settledAmount": 2481.24
  },
  {
    "date": "2026-01-20",
    "clientName": "Pierre Lampaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xfd6853d29B6547e6DF8fE4EAFd331bB00E7F1e40",
    "methodToken": "ETH",
    "settledAmount": 3114.33
  },
  {
    "date": "2026-01-26",
    "clientName": "Pierre Lampaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x5A67b6d0eFC5BF8DB3e35A9E0c2Dd4043fFe194D",
    "methodToken": "USDT - ERC20",
    "settledAmount": 5045.69
  },
  {
    "date": "2026-01-26",
    "clientName": "Pierre Lampaert",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x5A67b6d0eFC5BF8DB3e35A9E0c2Dd4043fFe194D",
    "methodToken": "USDT - ERC20",
    "settledAmount": 2119.19
  },
  {
    "date": "2026-01-27",
    "clientName": "Pierre Lampaert",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xc2E75AD3b29ad7Cf4C4b561c5a8f96949dF766Ac",
    "methodToken": "ETH",
    "settledAmount": 124.79
  },
  {
    "date": "14/03/2025",
    "clientName": "Raf Vaessen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1C6AsNu3QHQ7RCZpVFHGWpYr5Xfp6bjs51",
    "methodToken": "BTC",
    "settledAmount": 10805.47
  },
  {
    "date": "2025-02-04",
    "clientName": "Raf Vaessen",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xfd2c2df696F56fCe3467B456b8C0F6D294699850",
    "methodToken": "USDT-ERC20",
    "settledAmount": 208.0
  },
  {
    "date": "2025-12-05",
    "clientName": "Raf Vaessen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1C6AsNu3QHQ7RCZpVFHGWpYr5Xfp6bjs51",
    "methodToken": "BTC",
    "settledAmount": 27924.0
  },
  {
    "date": "21/05/2025",
    "clientName": "Raf Vaessen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x4988b4f1AF34e85fDd9f3a5Db24c2C58a4678b27",
    "methodToken": "USDC-ERC20",
    "settledAmount": 5637.0
  },
  {
    "date": "2025-01-23",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "TCnCdmqtKNSPwsjJYY6wWuzTR5okKTAqbj",
    "methodToken": "TRX-TRC20",
    "settledAmount": 858.31
  },
  {
    "date": "2025-11-02",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2517.0
  },
  {
    "date": "2025-12-02",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2962.0
  },
  {
    "date": "14/02/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3As1ZzjeFB7medYzW73WeKGy5eF3BXvmHE",
    "methodToken": "BTC",
    "settledAmount": 510.0
  },
  {
    "date": "14/02/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 4070.44
  },
  {
    "date": "14/02/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2154.86
  },
  {
    "date": "18/02/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 10017.0
  },
  {
    "date": "28/02/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 2537.0
  },
  {
    "date": "2025-12-03",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x1aCc355f3fFCE65a9f931613326c190E30e06B1D",
    "methodToken": "ETH-ERC20",
    "settledAmount": 5333.12
  },
  {
    "date": "2025-08-04",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x269661aB9Adc3194809D1551FC46e618243eCEeb",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3959.0
  },
  {
    "date": "2025-08-04",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x269661aB9Adc3194809D1551FC46e618243eCEeb",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1339.0
  },
  {
    "date": "26/05/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x269661aB9Adc3194809D1551FC46e618243eCEeb",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1208.0
  },
  {
    "date": "17/09/2025",
    "clientName": "Rahinatou Garba",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xeF786f4f2eCE9Cf198d0187F25754784657667bd",
    "methodToken": "ETH",
    "settledAmount": 8302.92
  },
  {
    "date": "2025-03-12",
    "clientName": "Rebecca Serr\u00e9",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3NL2V6PvgtJLDt3iLqUMeUHahBud81f9nQ",
    "methodToken": "BTC",
    "settledAmount": 184.94
  },
  {
    "date": "2026-01-26",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8fbBe07DDfb2a88836A87e32d25BD8A5F6cAA0B8",
    "methodToken": "USDT - ERC20",
    "settledAmount": 10090.78
  },
  {
    "date": "2026-01-28",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8fbBe07DDfb2a88836A87e32d25BD8A5F6cAA0B8",
    "methodToken": "USDT - ERC20",
    "settledAmount": 50778.68
  },
  {
    "date": "2026-02-03",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3Ld1diEj9VeHKNypoRMTKCf4iG7VHapLih",
    "methodToken": "BTC",
    "settledAmount": 1770.6
  },
  {
    "date": "2026-02-04",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8fbBe07DDfb2a88836A87e32d25BD8A5F6cAA0B8",
    "methodToken": "USDT - ERC20",
    "settledAmount": 15031.65
  },
  {
    "date": "2026-02-06",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x8fbBe07DDfb2a88836A87e32d25BD8A5F6cAA0B8",
    "methodToken": "USDT - ERC20",
    "settledAmount": 40073.88
  },
  {
    "date": "2026-02-12",
    "clientName": "Rik Goudeseune",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3Ld1diEj9VeHKNypoRMTKCf4iG7VHapLih",
    "methodToken": "BTC",
    "settledAmount": 2375.49
  },
  {
    "date": "2025-04-06",
    "clientName": "Rita Vanhie",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0xDf027f8F555298FbCB9aB5526d29a343194ace07",
    "methodToken": "USDC-ERC20",
    "settledAmount": 158.0
  },
  {
    "date": "2025-01-06",
    "clientName": "Robbe Herreman",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1PwxRSEp66sWafYh6kjDihoV86Y62KVB5v",
    "methodToken": "BTC",
    "settledAmount": 3034.66
  },
  {
    "date": "2025-01-06",
    "clientName": "Robbe Herreman",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "bc1qj23wnfg2t6y9r9kt57ylrpz6gjmhf9el8q3q0y",
    "methodToken": "BTC",
    "settledAmount": 60.0
  },
  {
    "date": "2026-01-29",
    "clientName": "Ronny Verheyen",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xb8769C2f5f3F4Cab3910350DDB816f264447B5F5",
    "methodToken": "ETH",
    "settledAmount": 1201.24
  },
  {
    "date": "2025-02-05",
    "clientName": "Rosa Sermon",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1PfECMMm73C6WVcXywHeYMtugJ72QCjHxN",
    "methodToken": "BTC",
    "settledAmount": 5145.66
  },
  {
    "date": "2025-01-27",
    "clientName": "Saida Trabelssi",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1KRQWPtE1ySveT5QtLeXV25smsv1oSwY6h",
    "methodToken": "BTC",
    "settledAmount": 463.0
  },
  {
    "date": "2025-10-02",
    "clientName": "Saida Trabelssi",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1KRQWPtE1ySveT5QtLeXV25smsv1oSwY6h",
    "methodToken": "BTC",
    "settledAmount": 1425.0
  },
  {
    "date": "16/07/2025",
    "clientName": "Samuel Covaci",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x5fb9bEd1D8BbcD71AC624E7a962864f973Bc4cF0",
    "methodToken": "ETH",
    "settledAmount": 146.0
  },
  {
    "date": "2025-01-13",
    "clientName": "Sara Willems",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x80a1265216Fe7f1Ab9C5Bd26c50DAc36e72c5e8A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 482.0
  },
  {
    "date": "2025-01-31",
    "clientName": "Sara Willems",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x80a1265216Fe7f1Ab9C5Bd26c50DAc36e72c5e8A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 998.0
  },
  {
    "date": "2025-01-31",
    "clientName": "Sara Willems",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x80a1265216Fe7f1Ab9C5Bd26c50DAc36e72c5e8A",
    "methodToken": "ETH-ERC20",
    "settledAmount": 493.0
  },
  {
    "date": "25/02/2025",
    "clientName": "Sonia Molenberghs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1D2t3TvYDAuW8nJWZG3NWGBVU13jyH1FV",
    "methodToken": "BTC",
    "settledAmount": 2031.81
  },
  {
    "date": "27/03/2025",
    "clientName": "Sonia Molenberghs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1D2t3TvYDAuW8nJWZG3NWGBVU13jyH1FV",
    "methodToken": "BTC",
    "settledAmount": 2100.0
  },
  {
    "date": "2025-03-04",
    "clientName": "Sonia Molenberghs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1D2t3TvYDAuW8nJWZG3NWGBVU13jyH1FV",
    "methodToken": "BTC",
    "settledAmount": 5381.0
  },
  {
    "date": "15/04/2025",
    "clientName": "Sonia Molenberghs",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1D2t3TvYDAuW8nJWZG3NWGBVU13jyH1FV",
    "methodToken": "BTC",
    "settledAmount": 2802.0
  },
  {
    "date": "2025-06-03",
    "clientName": "Soufiane Boulbane",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1EUbExx3oDPUbLFqKtAgNouk9RyBUW5Mew",
    "methodToken": "BTC",
    "settledAmount": 2717.0
  },
  {
    "date": "26/03/2025",
    "clientName": "Soufiane Boulbane",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1EUbExx3oDPUbLFqKtAgNouk9RyBUW5Mew",
    "methodToken": "BTC",
    "settledAmount": 1278.0
  },
  {
    "date": "2025-03-04",
    "clientName": "Soufiane Boulbane",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1EUbExx3oDPUbLFqKtAgNouk9RyBUW5Mew",
    "methodToken": "BTC",
    "settledAmount": 2875.0
  },
  {
    "date": "2025-11-04",
    "clientName": "Soufiane Boulbane",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "18S7G933Qf2tGzqwatMt4kSzx2C4NCMm41",
    "methodToken": "BTC",
    "settledAmount": 110.0
  },
  {
    "date": "2025-11-04",
    "clientName": "Soufiane Boulbane",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1EUbExx3oDPUbLFqKtAgNouk9RyBUW5Mew",
    "methodToken": "BTC",
    "settledAmount": 10185.0
  },
  {
    "date": "2025-09-04",
    "clientName": "Stijn Van Hecke",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x16F54D2bC8E848A42763A158F79441B1F23543E5",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1548.0
  },
  {
    "date": "2025-09-04",
    "clientName": "Stijn Van Hecke",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x16F54D2bC8E848A42763A158F79441B1F23543E5",
    "methodToken": "ETH-ERC20",
    "settledAmount": 3810.0
  },
  {
    "date": "2025-01-30",
    "clientName": "Tahar Ben Abbes",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0x69d082B46Ac971e00D16885a99a28555440d897B",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1038.49
  },
  {
    "date": "2025-01-28",
    "clientName": "Thomas Janssens",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 260.0
  },
  {
    "date": "2026-02-10",
    "clientName": "Veerle DeCuyper",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "3KUhdZEypcHKFcDrmGiBzeZTgr3jHKhpCo",
    "methodToken": "BTC",
    "settledAmount": 118.15
  },
  {
    "date": "17/02/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "1CYXa6kbHcqmLEG9rnGYQehXFGZ1NLaEvV",
    "methodToken": "BTC",
    "settledAmount": 36.0
  },
  {
    "date": "19/02/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1ALmWAXzBajobo6JDKbGqhBKMA53gmDhRE",
    "methodToken": "BTC",
    "settledAmount": 2037.45
  },
  {
    "date": "21/04/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xddFa1122b5d03f2EA326be478dCa49526a9570dc",
    "methodToken": "ETH-ERC20",
    "settledAmount": 564.0
  },
  {
    "date": "28/04/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xddFa1122b5d03f2EA326be478dCa49526a9570dc",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1025.0
  },
  {
    "date": "28/04/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xddFa1122b5d03f2EA326be478dCa49526a9570dc",
    "methodToken": "ETH-ERC20",
    "settledAmount": 1024.0
  },
  {
    "date": "28/04/2025",
    "clientName": "Veerle Florenty",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "0xddFa1122b5d03f2EA326be478dCa49526a9570dc",
    "methodToken": "ETH-ERC20",
    "settledAmount": 504.0
  },
  {
    "date": "26/09/2025",
    "clientName": "Victor Bud",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "CHB",
    "methodToken": "",
    "settledAmount": 250.0
  },
  {
    "date": "23/10/2025",
    "clientName": "Victor Maes",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x1e82506d54db26b85af3c69c8caf813151ef48a5",
    "methodToken": "USDC-ERC20",
    "settledAmount": 90.0
  },
  {
    "date": "2025-07-03",
    "clientName": "walizai Walizai",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "REFUND",
    "methodToken": "",
    "settledAmount": 260.0
  },
  {
    "date": "2025-01-27",
    "clientName": "Wens Renaat",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1MHgffymrgmnBVuHx6rvv3eeaqXuyaUBm",
    "methodToken": "BTC",
    "settledAmount": 2029.39
  },
  {
    "date": "2025-12-02",
    "clientName": "Wens Renaat",
    "country": "Belgium",
    "type": "Deposit",
    "wallet": "1MHgffymrgmnBVuHx6rvv3eeaqXuyaUBm",
    "methodToken": "BTC",
    "settledAmount": 3042.0
  },
  {
    "date": "2025-10-07",
    "clientName": "Willy Van Trichtveldt",
    "country": "Belgium",
    "type": "Withdrawal",
    "wallet": "0x6b477378F93C754AD47Fb3c4504daD1b79B8EbCd",
    "methodToken": "USDC - ERC20",
    "settledAmount": 208.0
  }
];
